/**
 * 为了处理数据库地名和JSON数据地名不一致问题；
 * 设置一个名称映射对象；
 * 例如： [JSON数据名称]:[data数据名（来自服务器数据）]
 *        "黄山区"："黄山"
 */
// 地名数据映射
export const nameMap = {
  '上海市': '上海',
  '北京市': '北京',
  '重庆市': '重庆',
  '天津市': '天津',
  '新疆维吾尔自治区':'新疆',
  '西藏自治区':'西藏',
  '青海省':'青海',
  '甘肃省':'甘肃',
  '宁夏回族自治区':'宁夏',
  '内蒙古自治区':'内蒙古',
  '四川省':'四川',
  '贵州省':'贵州',
  '云南省':'云南',
  '陕西省':'陕西',
  '山西省':'山西',
  '黑龙江省':'黑龙江',  // [126.642464,45.756967][127.63333,47.75000]
  '吉林省':'吉林',
  '广西壮族自治区':'广西',
  '湖南省':'湖南',
  '湖北省':'湖北',
  '山东省':'山东',
  '辽宁省':'辽宁',
  '江西省':'江西',
  '福建省':'福建',
  '广东省':'广东',
  '江苏省':'江苏',
  '安徽省':'安徽',
  '河南省':'河南',
  '河北省':'河北',
  '浙江省':'浙江',
  '海南省':'海南',
  '台湾省':'台湾',
  '香港特别行政区':'香港',
  '澳门特别行政区':'澳门',
}

// 缩写映射
export const nameData = {
  YB: {
    youthName: '延边足协',
    mapName: '延边'
  },
  SD: {
    youthName: '山东足协',
    mapName: '山东'
  },
  AH: {
    youthName: '安徽足协',
    mapName: '安徽'
  },
  HB: {
    youthName: '湖北足协',
    mapName: '湖北'
  },
  GD: {
    youthName: '广东足协',
    mapName: '广东'
  },
  WH: {
    youthName: '武汉足协',
    mapName: '武汉'
  },
  HA: {
    youthName: '河南足协',
    mapName: '河南'
  },
  GH: {
    youthName: '广州足协',
    mapName: '广州'
  },
  JX: {
    youthName: '江西足协',
    mapName: '江西'
  },
  CC: {
    youthName: '长春足协',
    mapName: '长春'
  },
  XM: {
    youthName: '厦门足协',
    mapName: '厦门'
  },
  DL: {
    youthName: '大连足协',
    mapName: '大连'
  },
  LN: {
    youthName: '辽宁足协',
    mapName: '辽宁'
  },
  HL: {
    youthName: '黑龙江足协',
    mapName: '黑龙江'
  },
  JS: {
    youthName: '江苏足协',
    mapName: '江苏'
  },
  QH: {
    youthName: '青海足协',
    mapName: '青海'
  },
  NJ: {
    youthName: '南京足协',
    mapName: '南京'
  },
  JL: {
    youthName: '吉林足协',
    mapName: '吉林'
  },
  BJ: {
    youthName: '北京市足协',
    mapName: '北京'
  },
  HI: {
    youthName: '海南足协',
    mapName: '海南'
  },
  FJ: {
    youthName: '福建足协',
    mapName: '福建'
  },
  SN: {
    youthName: '山西足协',
    mapName: '山西'
  },
  HE: {
    youthName: '河北足协',
    mapName: '河北'
  },
  SZ: {
    youthName: '深圳足协',
    mapName: '深圳'
  },
  NX: {
    youthName: '宁夏足协',
    mapName: '宁夏'
  },
  HN: {
    youthName: '湖南足协',
    mapName: '湖南'
  },
  SC: {
    youthName: '四川足协',
    mapName: '四川'
  },
  YN: {
    youthName: '云南足协',
    mapName: '云南'
  },
  CQ: {
    youthName: '重庆足协',
    mapName: '重庆'
  },
  ZZ: {
    youthName: '中国足校',
    mapName: '中国地图'
  },
  KM: {
    youthName: '昆明足协',
    mapName: '昆明'
  },
  SY: {
    youthName: '沈阳足协',
    mapName: '沈阳'
  },
  GZ: {
    youthName: '贵州足协',
    mapName: '贵州'
  },
  XA: {
    youthName: '西安足协',
    mapName: '西安'
  },
  MK: {
    youthName: '煤矿体协',
    mapName: '中国地图'
  },
  HC: {
    youthName: '火车头体协',
    mapName: '中国地图'
  },
  ZJ: {
    youthName: '浙江足协',
    mapName: '浙江'
  },
  XJ: {
    youthName: '新疆足协',
    mapName: '新疆'
  },
  NM: {
    youthName: '内蒙古足协',
    mapName: '内蒙古'
  },
  TJ: {
    youthName: '天津足协',
    mapName: '天津'
  },
  CD: {
    youthName: '成都足协',
    mapName: '成都'
  },
  SX: {
    youthName: '陕西足协',
    mapName: '陕西'
  },
  QD: {
    youthName: '青岛足协',
    mapName: '青岛'
  },
  SH: {
    youthName: '上海足协',
    mapName: '上海'
  },
  GX: {
    youthName: '广西足协',
    mapName: '广西'
  },
  DX: {
    youthName: '大体协',
    mapName: '中国地图'
  },
  XZ: {
    youthName: '西藏足协',
    mapName: '西藏'
  },
  GS: {
    youthName: '甘肃足协',
    mapName: '甘肃'
  },
  BT: {
    youthName: '北体大',
    mapName: '中国地图'
  },
  XY: {
    youthName: '全国校足办',
    mapName: '中国地图'
  },
  QY: {
    youthName: '中企体协',
    mapName: '中国地图'
  },
  TK: {
    youthName: '兵团足协',
    mapName: '新疆'
  },
}

export function getOrgInfoByCode(code) {
  return nameData[code]
}
